import * as React from "react";
import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";

export const useV9MenuEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(appContext, ribbonExperiments.fluentV9MenuIsEnabled);
};

export const useV9MenuAutoDismissFixEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.v9MenuAutoDismissFixEnabled
  );
};

export const useFixOnMenuOpenedTriggerOnSubmenuHoverEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.fixOnMenuOpenedTriggerOnSubmenuHover
  );
};

export const useDispatchOptimizationEnabled = () => {
  // When this CG is enabled, the V9 Menu is not removed from the DOM on dismiss.
  // Rather, it stays in the DOM with toggled visibility. This is aimed to optimize rendering performance of CM.
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.isFluentV9DispatchOptimizationEnabled
  );
};

export const useTriggerOnMenuDismissedOnSubmenuClose = () => {
  // When this CG is enabled, onMenuDismissed cb is fired whenever a submenu closes.
  // This is to ensure that the react modal div no more remains visible in the DOM. VSO - 8990579
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.triggerOnMenuDismissedOnSubmenuClose
  );
};

export const useShadowOverflowFixEnabled = () => {
  // When this CG is enabled, the shadow of the CM doesn't fall on the floatie.
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.isShadowOverflowFixEnabled
  );
};

export const useShortcutPillsEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.fluentV9ShortcutPillsIsEnabled
  );
};

export const useContextMenuAndFloatieRightClickDisabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.isContextMenuAndFloatieRightClickDisabled
  );
};
